export default {
  IMAGE: ['image/*'],
  DOC: ['.doc', '.docx', '.pdf'],
};



// WEBPACK FOOTER //
// ./src/variables/mimeTypes.js